export default __webpack_public_path__ + "static/assets/ccc994f6531e23f20cb1a4677f6dc94d.png";